import {
  Code2,
  Database,
  Cloud,
  Brain,
  Layers,
  Terminal,
  Palette,
  Server,
  GitBranch,
  Cpu,
  Globe,
  Zap,
  Network,
  Bot,
  Sparkles,
} from "lucide-react";

// Full Stack Development Skills
export const fullStackSkills = [
  {
    id: 1,
    title: "React.js",
    date: "Expert",
    content: "Building modern, scalable web applications with React. Expert in hooks, context, and performance optimization.",
    category: "Frontend",
    icon: Code2,
    relatedIds: [2, 3, 4],
    status: "expert",
    energy: 95,
  },
  {
    id: 2,
    title: "Next.js",
    date: "Expert",
    content: "Server-side rendering and static site generation. Full-stack React framework with API routes.",
    category: "Frontend",
    icon: Terminal,
    relatedIds: [1, 3],
    status: "expert",
    energy: 90,
  },
  {
    id: 3,
    title: "Tailwind CSS",
    date: "Expert",
    content: "Utility-first CSS framework. Responsive design, custom themes, and component styling.",
    category: "Frontend",
    icon: Palette,
    relatedIds: [1, 2],
    status: "expert",
    energy: 92,
  },
  {
    id: 4,
    title: "JavaScript",
    date: "Expert",
    content: "Modern ES6+ JavaScript. Async/await, promises, destructuring, and advanced patterns.",
    category: "Frontend",
    icon: Code2,
    relatedIds: [1, 5],
    status: "expert",
    energy: 94,
  },
  {
    id: 5,
    title: "Node.js",
    date: "Expert",
    content: "Backend development with Node.js and Express. RESTful APIs, microservices, and real-time applications.",
    category: "Backend",
    icon: Server,
    relatedIds: [4, 6, 7],
    status: "expert",
    energy: 88,
  },
  {
    id: 6,
    title: "MongoDB",
    date: "Expert",
    content: "NoSQL database design and optimization. Aggregation pipelines, indexing, and data modeling.",
    category: "Database",
    icon: Database,
    relatedIds: [5, 7],
    status: "expert",
    energy: 85,
  },
  {
    id: 7,
    title: "MySQL",
    date: "Proficient",
    content: "Relational database management. Complex queries, transactions, and database optimization.",
    category: "Database",
    icon: Database,
    relatedIds: [5, 6],
    status: "proficient",
    energy: 82,
  },
  {
    id: 8,
    title: "Git",
    date: "Expert",
    content: "Version control and collaboration. Branching strategies, code review, and CI/CD integration.",
    category: "DevOps",
    icon: GitBranch,
    relatedIds: [9],
    status: "expert",
    energy: 94,
  },
  {
    id: 9,
    title: "Deployment",
    date: "Proficient",
    content: "Cloud deployment and hosting. Vercel, Netlify, AWS, and containerization with Docker.",
    category: "DevOps",
    icon: Cloud,
    relatedIds: [8, 10],
    status: "proficient",
    energy: 80,
  },
  {
    id: 10,
    title: "SEO",
    date: "Proficient",
    content: "Search engine optimization. Meta tags, structured data, performance optimization, and accessibility.",
    category: "Web",
    icon: Globe,
    relatedIds: [1, 2, 9],
    status: "proficient",
    energy: 78,
  },
];

// AI Engineer Skills
export const aiEngineerSkills = [
  {
    id: 1,
    title: "LangChain",
    date: "Expert",
    content: "Building LLM applications with LangChain. Chains, agents, memory, and tool integration.",
    category: "AI Framework",
    icon: Network,
    relatedIds: [2, 3],
    status: "expert",
    energy: 92,
  },
  {
    id: 2,
    title: "LangGraph",
    date: "Expert",
    content: "Stateful multi-agent workflows. Complex agent orchestration and graph-based reasoning.",
    category: "AI Framework",
    icon: Layers,
    relatedIds: [1, 3],
    status: "expert",
    energy: 90,
  },
  {
    id: 3,
    title: "Agentic AI",
    date: "Expert",
    content: "Building autonomous AI agents. Tool use, planning, reasoning, and multi-agent systems.",
    category: "AI Agents",
    icon: Bot,
    relatedIds: [1, 2, 4],
    status: "expert",
    energy: 88,
  },
  {
    id: 4,
    title: "CREW AI",
    date: "Proficient",
    content: "Multi-agent collaboration framework. Role-based agents, task delegation, and team coordination.",
    category: "AI Agents",
    icon: Bot,
    relatedIds: [3],
    status: "proficient",
    energy: 85,
  },
  {
    id: 5,
    title: "MCP",
    date: "Proficient",
    content: "Model Context Protocol. Standardized AI model integration and context management.",
    category: "AI Protocol",
    icon: Network,
    relatedIds: [1],
    status: "proficient",
    energy: 80,
  },
  {
    id: 6,
    title: "RAG",
    date: "Expert",
    content: "Retrieval-Augmented Generation. Vector search, embeddings, and knowledge retrieval.",
    category: "AI Technique",
    icon: Sparkles,
    relatedIds: [7, 8],
    status: "expert",
    energy: 90,
  },
  {
    id: 7,
    title: "Vector DBs",
    date: "Proficient",
    content: "Vector databases for AI. Pinecone, Weaviate, ChromaDB, and similarity search.",
    category: "Database",
    icon: Database,
    relatedIds: [6],
    status: "proficient",
    energy: 82,
  },
  {
    id: 8,
    title: "LLMs",
    date: "Expert",
    content: "Large Language Models. GPT-4, Claude, Llama, prompt engineering, and fine-tuning.",
    category: "AI Models",
    icon: Brain,
    relatedIds: [6, 9],
    status: "expert",
    energy: 94,
  },
  {
    id: 9,
    title: "Hugging Face",
    date: "Proficient",
    content: "Model hub and transformers library. Model deployment, fine-tuning, and inference.",
    category: "AI Platform",
    icon: Cpu,
    relatedIds: [8],
    status: "proficient",
    energy: 83,
  },
  {
    id: 10,
    title: "MLOps",
    date: "Proficient",
    content: "ML operations and deployment. Model versioning, monitoring, and production pipelines.",
    category: "Operations",
    icon: Zap,
    relatedIds: [9],
    status: "proficient",
    energy: 78,
  },
];
